import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IPaymentAch } from '../_shared/interfaces/IPayment';
import { CustomResponse } from '../_shared/classes/CustomResponse';
import { BaseService } from '../services/base-service.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  get(id: number): Observable<CustomResponse<any>> {
    return this.http.get<CustomResponse<any>>(this.buildXenithEndpoint(`/HighValuePayment/${id}`), this.GetAuthHeaderJson());
  }

  getByQuote(quoteId: number): Observable<CustomResponse<any>> {
    return this.http.get<CustomResponse<any>>(this.buildXenithEndpoint(`/HighValuePayment/getPaymentByQuoteId/${quoteId}`), this.GetAuthHeaderJson());
  }

  save(item: IPaymentAch) {
    return this.http.post<CustomResponse<any>>(this.buildXenithEndpoint(`/HighValuePayment`), item, this.GetAuthHeaderJson());
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.log("error in service");
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
